import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorMsg, Input } from '@fragments';
import { LIMITS, REMINDER_DELAYS } from '../../../../../enums/automations';
import { formatDelay } from '../../../utils/format';
import PlanMark from '../../../components/PlanMark';
import { LinkRows, MessageField, ToggleCard } from './parts';

const LINK_LIMIT = { count: LIMITS.buttons, title: LIMITS.buttonTitle };
// With buttons, Meta's button template keeps the text to 640 characters.
const textLimit = message => (message.buttons.length ? LIMITS.deliveryWithButtons : LIMITS.deliveryText);

// "E por fim recebe": the delivery, whose links are tracked, and the reminder for who did not open it.
export default function DeliveryStep({ studio: s, editor }) {
  const { t } = useTranslation('studioAutomations');
  const { draft, errors, update } = editor;
  const { delivery, reminder } = draft.dm;
  const gates = s.automations.gates || {};
  return <div className="studio-automation-step__fields">
    <div className="studio-automation-option is-chosen is-static">
      <div className="studio-automation-option__body">
        <MessageField label={t('deliveryText')} value={delivery.text} onChange={value => update('dm.delivery.text', value)} max={textLimit(delivery)} error={errors['dm.delivery.text']?.[0]} placeholder={t('deliveryPlaceholder')} />
        <LinkRows buttons={delivery.buttons} onChange={value => update('dm.delivery.buttons', value)} limit={LINK_LIMIT} path="dm.delivery" errors={errors} />
      </div>
    </div>
    <ToggleCard on={reminder.enabled} onChange={value => update('dm.reminder.enabled', value)} title={t('reminderTitle')} hint={t('reminderHint')} mark={<PlanMark studio={s} required={gates.reminder} />}>
      {errors['dm.reminder.enabled'] && <ErrorMsg>{errors['dm.reminder.enabled'][0]}</ErrorMsg>}
      <Input.Select label={t('reminderDelay')} value={reminder.delay_minutes} onInput={value => update('dm.reminder.delay_minutes', value)} options={REMINDER_DELAYS.map(value => ({ value, label: formatDelay(value, s.locale) }))} />
      <MessageField label={t('reminderText')} rows={3} value={reminder.message.text} onChange={value => update('dm.reminder.message.text', value)} max={textLimit(reminder.message)} error={errors['dm.reminder.message.text']?.[0]} placeholder={t('reminderPlaceholder')} />
      <LinkRows buttons={reminder.message.buttons} onChange={value => update('dm.reminder.message.buttons', value)} limit={LINK_LIMIT} path="dm.reminder.message" errors={errors} />
    </ToggleCard>
  </div>;
}
